import { FormikErrors } from 'formik';

export const emailValidator = (email: any): string | undefined => {
  if (!email) {
    return 'Please enter your email';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
    return 'Invalid email address';
  }
};

export const authFormValidator = <T extends { email: string; phone: string }>(
  values: T,
  isEmailAuthType: boolean,
  phoneError: string | null,
) => {
  const errors: Partial<Record<keyof T, string>> = {};
  if (isEmailAuthType) {
    const emailError = emailValidator(values.email);
    if (emailError) {
      errors.email = emailError;
    }
  } else {
    if (!values.phone || phoneError) {
      errors.phone = phoneError || 'Please enter your phone number';
    }
  }
  return errors;
};

export const authFormValidatorWithPassword = (
  values: { email: string; phone: string; password: string },
  isEmailAuthType: boolean,
  phoneError: string | null,
) => {
  const errors = authFormValidator(
    values,
    isEmailAuthType,
    phoneError,
  ) as FormikErrors<typeof values & { password: string }>;
  if (!values.password) {
    errors.password = 'Please enter your password';
  }
  return errors;
};
